import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/aariniconsulting.webp';
import screenshot_target from '../../../images/letterfunnel/harikishoresreenivasalu.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Harikishore Sreenivasalu"
      firstname="Harikishore"
      companyname="Aarini Consulting"
      competition="McCoy & Partners en Ctac"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/harikishoresreenivasalu.js